/** UI copy for DigiFriendo — Polski + English */
export const SUPPORTED = [
  { code: 'pl', label: 'Polski', flag: 'PL' },
  { code: 'en', label: 'English', flag: 'GB' },
];

export const strings = {
  pl: {
    brand: 'DigiFriendo',
    brandDomain: 'digifriendo.com',
    nav: {
      home: 'Strona główna',
      discover: 'Odkryj',
      features: 'Funkcje',
      benefits: 'Korzyści',
      faq: 'FAQ',
      contact: 'Kontakt',
    },
    headerCta: 'Zacznij teraz',
    hero: {
      badge: 'Twój cyfrowy przyjaciel AI',
      titleA: 'Poznaj swojego',
      titleB: 'AI Przyjaciela',
      titleC: 'Zawsze dostępny. Zawsze pomocny.',
      lead: 'DigiFriendo to Twój osobisty asystent AI w formie awatara — rozmawia z Tobą, pomaga w codziennych zadaniach, uczy się Twoich preferencji i wspiera Cię 24/7.',
      ctaPrimary: 'Zacznij teraz',
      ctaSecondary: 'Dowiedz się więcej',
      legal:
        'Płatna cotygodniowa subskrypcja. Płatność przez Mobile Billing (rachunek telefoniczny). Rejestrując się akceptujesz nasz Regulamin. Anulowanie w dowolnym momencie. Wsparcie: support@digifriendo.com. Dostawca: Niffo Mobile B.V.',
      statTitle: '50 000+ użytkowników',
      statSub: 'z pomocą swojego AI przyjaciela',
      priceChip: 'Tygodniowa subskrypcja',
    },
    discover: {
      kicker: 'Odkryj',
      title: 'Twój AI awatar —',
      titleGrad: 'zawsze przy Tobie',
      body: 'DigiFriendo to więcej niż asystent — to cyfrowy przyjaciel, który rozumie Twój kontekst, uczy się Twoich zwyczajów i angażuje się w prawdziwe rozmowy.',
      devicesTitle: 'Dostępny wszędzie',
      devicesSub: 'Przeglądarka, smartfon lub tablet — bez instalacji.',
    },
    features: {
      kicker: 'W portalu',
      items: [
        {
          title: 'Awatar AI',
          description:
            'Twój spersonalizowany cyfrowy przyjaciel, który rozmawia, słucha i reaguje jak prawdziwa osoba.',
        },
        {
          title: 'Codzienne zadania',
          description:
            'Przypomnienia, lista zadań, planowanie dnia — DigiFriendo ogarnie za Ciebie.',
        },
        {
          title: 'Inteligentne rozmowy',
          description:
            'Prowadź naturalne dialogi z AI, który naprawdę Cię rozumie i zapamiętuje kontekst.',
        },
        {
          title: 'Personalizacja',
          description:
            'Awatar uczy się Twoich preferencji i z czasem staje się coraz lepszym przyjacielem.',
        },
        {
          title: 'Treści i kreatywność',
          description:
            'Generuj teksty, pomysły i treści z pomocą AI — szybko i efektywnie.',
        },
        {
          title: 'Wsparcie 24/7',
          description:
            'DigiFriendo jest zawsze dostępny — dzień i noc, na każdym urządzeniu.',
        },
      ],
    },
    how: {
      kicker: 'Jak to działa',
      title: 'Trzy kroki do',
      titleGrad: 'Twojego przyjaciela',
      intro:
        'Zarejestruj się, spersonalizuj awatara i zacznij rozmawiać — DigiFriendo jest gotowy w kilka sekund.',
      blocks: [
        {
          title: 'Zarejestruj się',
          description: 'Załóż konto e-mailem i hasłem — gotowe w kilka sekund.',
          points: ['Szybka rejestracja', 'Bezpieczne dane', 'Natychmiastowy dostęp'],
        },
        {
          title: 'Stwórz awatara',
          description: 'Dostosuj wygląd i osobowość swojego AI przyjaciela.',
          points: ['Wybierz wygląd', 'Ustaw osobowość', 'Twój styl'],
        },
        {
          title: 'Rozmawiaj i działaj',
          description: 'Zacznij rozmawiać, zlecaj zadania i korzystaj z pełnej mocy AI.',
          points: ['Naturalne dialogi', 'Mądrze organizuj', 'Zawsze aktywny'],
        },
      ],
    },
    advantages: {
      kicker: 'Twoje korzyści',
      title: 'Cyfrowy przyjaciel.',
      titleGrad: 'Zawsze po Twojej stronie.',
      intro:
        'DigiFriendo łączy moc AI z ciepłem prawdziwego towarzysza — zawsze dostępny, zawsze pomocny.',
      quote: 'Twój AI przyjaciel na każdy dzień.',
      quoteSub:
        'Oszczędzaj czas, organizuj życie i rozmawiaj z kimś, kto naprawdę rozumie Twoje potrzeby.',
      bullets: [
        'Personalizowany awatar AI.',
        'Dostępny 24/7 na każdym urządzeniu.',
        'Uczy się i zapamiętuje Twoje preferencje.',
      ],
      cta: 'Zacznij teraz',
      panelTitle: 'AI Awatar',
      panelKicker: 'CYFROWY KOMPAN',
      panelBody:
        'Twój awatar rośnie razem z Tobą — im więcej rozmawiasz, tym lepiej Cię rozumie.',
      panelSub:
        'Prowadź rozmowy, zlecaj zadania i ciesz się prawdziwym cyfrowym przyjacielem.',
      imageAlt: 'Osoba rozmawiająca z AI awatarem',
      panelAlt: 'Cyfrowy awatar AI',
    },
    cta: {
      badge: 'Gotowy na cyfrowego przyjaciela?',
      title: 'Zacznij teraz',
      titleSub: 'z DigiFriendo.',
      body: 'Odblokuj pełen dostęp — spersonalizowany awatar AI, codzienne wsparcie i inteligentne rozmowy.',
      perks: [
        'Pełny dostęp do portalu',
        'Spersonalizowany awatar',
        'Anuluj w dowolnym momencie',
        'Wszystkie nowoczesne przeglądarki',
      ],
      button: 'Zacznij teraz',
      priceLine: 'Tygodniowa subskrypcja — płatność przez Mobile Billing.',
      helpLine: 'Wsparcie: support@digifriendo.com',
      legalBox:
        'DigiFriendo jest płatnym serwisem AI. Rejestrując się akceptujesz Regulamin. Subskrypcja odnawia się automatycznie do momentu anulowania. Płatność przez Mobile Billing. Dostawca: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Holandia.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Najczęstsze',
      titleGrad: 'pytania',
      intro: 'Odpowiedzi na najważniejsze pytania o DigiFriendo.',
      items: [
        {
          q: 'Czym jest DigiFriendo?',
          a: 'DigiFriendo to cyfrowy asystent AI w formie spersonalizowanego awatara, który pomaga w codziennych zadaniach, rozmawia z Tobą i uczy się Twoich preferencji.',
        },
        {
          q: 'Jak się zarejestrować?',
          a: 'Kliknij „Zacznij teraz", podaj adres e-mail i hasło — i gotowe.',
        },
        {
          q: 'Ile kosztuje DigiFriendo?',
          a: 'DigiFriendo to płatna usługa w formie tygodniowej subskrypcji. Płatność przez Mobile Billing.',
        },
        {
          q: 'Czy mogę anulować subskrypcję?',
          a: 'Tak, możesz anulować w dowolnym momencie. Anulowanie wchodzi w życie na koniec bieżącego okresu rozliczeniowego.',
        },
        {
          q: 'Jakie urządzenia są obsługiwane?',
          a: 'DigiFriendo działa na nowoczesnych przeglądarkach (Chrome, Safari, Firefox, Edge) oraz na smartfonach i tabletach.',
        },
      ],
      contactTitle: 'Masz więcej pytań?',
      contactLead: 'Napisz do nas — chętnie pomożemy.',
      email: 'support@digifriendo.com',
    },
    footer: {
      blurb:
        'DigiFriendo — Twój cyfrowy przyjaciel AI. Spersonalizowany awatar zawsze po Twojej stronie. Dostawca: Niffo Mobile B.V.',
      legalShort:
        'Płatna tygodniowa subskrypcja. Anulowanie w dowolnym momencie. Szczegóły w Regulaminie.',
      navTitle: 'Nawigacja',
      contactTitle: 'Kontakt',
      cta: 'Zacznij teraz →',
      copyright: 'DigiFriendo. Niffo Mobile B.V. Wszelkie prawa zastrzeżone.',
      agb: 'Regulamin',
      privacy: 'Prywatność',
      help: 'Pomoc',
      imprint: 'Impressum',
      widerruf: 'Odstąpienie',
    },
  },

  en: {
    brand: 'DigiFriendo',
    brandDomain: 'digifriendo.com',
    nav: {
      home: 'Home',
      discover: 'Discover',
      features: 'Features',
      benefits: 'Benefits',
      faq: 'FAQ',
      contact: 'Contact',
    },
    headerCta: 'Get started',
    hero: {
      badge: 'Your digital AI friend',
      titleA: 'Meet your',
      titleB: 'AI Companion',
      titleC: 'Always available. Always helpful.',
      lead: 'DigiFriendo is your personal AI assistant in avatar form — it talks to you, helps with daily tasks, learns your preferences, and supports you 24/7.',
      ctaPrimary: 'Get started',
      ctaSecondary: 'Learn more',
      legal:
        'Paid weekly subscription. Payment via mobile billing. By subscribing you accept our terms. Cancel anytime. Support: support@digifriendo.com. Provider: Niffo Mobile B.V.',
      statTitle: '50,000+ users',
      statSub: 'with their AI companion',
      priceChip: 'Weekly subscription',
    },
    discover: {
      kicker: 'Discover',
      title: 'Your AI avatar —',
      titleGrad: 'always by your side',
      body: 'DigiFriendo is more than an assistant — it\'s a digital friend that understands your context, learns your habits, and engages in real conversations.',
      devicesTitle: 'Available everywhere',
      devicesSub: 'Browser, smartphone, or tablet — no installation needed.',
    },
    features: {
      kicker: 'Inside the portal',
      items: [
        {
          title: 'AI Avatar',
          description:
            'Your personalised digital friend that talks, listens, and responds like a real person.',
        },
        {
          title: 'Daily tasks',
          description:
            'Reminders, to-do lists, day planning — DigiFriendo handles it all for you.',
        },
        {
          title: 'Smart conversations',
          description:
            'Have natural dialogues with AI that truly understands you and remembers context.',
        },
        {
          title: 'Personalisation',
          description:
            'The avatar learns your preferences and becomes an even better friend over time.',
        },
        {
          title: 'Content & creativity',
          description:
            'Generate texts, ideas, and content with AI help — fast and effectively.',
        },
        {
          title: '24/7 support',
          description:
            'DigiFriendo is always available — day and night, on every device.',
        },
      ],
    },
    how: {
      kicker: 'How it works',
      title: 'Three steps to',
      titleGrad: 'your companion',
      intro:
        'Register, personalise your avatar, and start chatting — DigiFriendo is ready in seconds.',
      blocks: [
        {
          title: 'Register',
          description: 'Create an account with email and password — done in seconds.',
          points: ['Quick sign-up', 'Secure credentials', 'Instant access'],
        },
        {
          title: 'Create your avatar',
          description: 'Customise the look and personality of your AI friend.',
          points: ['Choose appearance', 'Set personality', 'Your style'],
        },
        {
          title: 'Chat & act',
          description: 'Start chatting, assign tasks, and use the full power of AI.',
          points: ['Natural dialogue', 'Smart organise', 'Always active'],
        },
      ],
    },
    advantages: {
      kicker: 'Your benefits',
      title: 'A digital friend.',
      titleGrad: 'Always on your side.',
      intro:
        'DigiFriendo combines the power of AI with the warmth of a real companion — always available, always helpful.',
      quote: 'Your AI friend for every day.',
      quoteSub:
        'Save time, organise life, and talk to someone who truly understands your needs.',
      bullets: [
        'Personalised AI avatar.',
        'Available 24/7 on every device.',
        'Learns and remembers your preferences.',
      ],
      cta: 'Get started',
      panelTitle: 'AI Avatar',
      panelKicker: 'DIGITAL COMPANION',
      panelBody:
        'Your avatar grows with you — the more you talk, the better it understands you.',
      panelSub:
        'Have conversations, assign tasks, and enjoy a true digital companion.',
      imageAlt: 'Person chatting with AI avatar',
      panelAlt: 'Digital AI avatar',
    },
    cta: {
      badge: 'Ready for your digital friend?',
      title: 'Start now',
      titleSub: 'with DigiFriendo.',
      body: 'Unlock full access — personalised AI avatar, daily support, and smart conversations.',
      perks: [
        'Full portal access',
        'Personalised avatar',
        'Cancel anytime',
        'All modern browsers',
      ],
      button: 'Get started',
      priceLine: 'Weekly subscription — payment via mobile billing.',
      helpLine: 'Support: support@digifriendo.com',
      legalBox:
        'DigiFriendo is a paid AI service. By subscribing you accept our terms. The subscription renews automatically unless cancelled. Payment via mobile billing. Provider: Niffo Mobile B.V., Stationsplein 28, 1382 AD Weesp, Netherlands.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Common',
      titleGrad: 'questions',
      intro: 'Answers to the most important questions about DigiFriendo.',
      items: [
        {
          q: 'What is DigiFriendo?',
          a: 'DigiFriendo is a digital AI assistant in the form of a personalised avatar that helps with daily tasks, talks with you, and learns your preferences.',
        },
        {
          q: 'How do I register?',
          a: 'Click "Get started", enter your email and password — and you\'re ready.',
        },
        {
          q: 'What does DigiFriendo cost?',
          a: 'DigiFriendo is a paid service as a weekly subscription. Payment via mobile billing.',
        },
        {
          q: 'Can I cancel my subscription?',
          a: 'Yes, you can cancel anytime. Cancellation takes effect at the end of the current billing period.',
        },
        {
          q: 'Which devices are supported?',
          a: 'DigiFriendo works on modern browsers (Chrome, Safari, Firefox, Edge) as well as smartphones and tablets.',
        },
      ],
      contactTitle: 'Still have questions?',
      contactLead: 'Write to us — we\'re happy to help.',
      email: 'support@digifriendo.com',
    },
    footer: {
      blurb:
        'DigiFriendo — your digital AI friend. A personalised avatar always by your side. Provider: Niffo Mobile B.V.',
      legalShort: 'Paid weekly subscription. Cancel anytime. See terms for details.',
      navTitle: 'Navigation',
      contactTitle: 'Contact',
      cta: 'Get started →',
      copyright: 'DigiFriendo. Niffo Mobile B.V. All rights reserved.',
      agb: 'Terms',
      privacy: 'Privacy',
      help: 'Help',
      imprint: 'Impressum',
      widerruf: 'Withdrawal',
    },
  },
};
